import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { Router, hashHistory } from 'react-router';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import { loadingBarMiddleware } from 'react-redux-loading-bar'
import reducers from './reducers';
import Config, {loadMainConfiguration} from "./constants/Configuration";

const middleware = routerMiddleware(hashHistory);
const store = createStore(
  reducers,
  applyMiddleware(
    thunkMiddleware,
    middleware,
    loadingBarMiddleware()
  )
);

const history = syncHistoryWithStore(hashHistory, store);

function scrollToTop() {
  window.scrollTo(0, 0);
}

loadMainConfiguration().then(() => {

  const rootRoute = {
    // onChange: LocationHelper.onRouteChange,
    // onEnter:  LocationHelper.onRouteChange,

    childRoutes: [{
      path: '/',
      component: require('./containers/App'),
      indexRoute: { onEnter: (nextState, replace) => replace('/login') },
      childRoutes: [
        require('./routes/app'),
        require('./routes/404'),
        require('./routes/500'),
        require('./routes/confirmEmail'),
        require('./routes/forgotPassword'),
        require('./routes/lockScreen'),
        require('./routes/login'),
        require('./routes/signUp'),
        require('./routes/fullscreen'),
        require('./routes/pickingList'),
        {
          path: '*',
          indexRoute: { onEnter: (nextState, replace) => replace('/404') },
        }
      ]
    }]
  };

  render(
    <Provider store={store}>
      <Router
        onUpdate={scrollToTop}
        history={history}
        routes={rootRoute}
      />
    </Provider>,
    document.getElementById('app-container')
  );
});

console.log('waiting for configuration to fully load');



// WEBPACK FOOTER //
// ./client.js